<script setup lang="ts">
import { Button } from "@/components/ui/button";
import { ArrowLeftIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const params = new URLSearchParams(window.location.search);
const next = params.get('next') || window.location.href;
let nextHostname = new URL(next).hostname;
if (nextHostname === `device-courier-orders.${import.meta.env.PUBLIC_DOMAIN_NAME}`) {
	nextHostname = 'Courier App'
}
if (nextHostname === `partner.${import.meta.env.PUBLIC_DOMAIN_NAME}`) {
	nextHostname = 'Partner Dashboard';
}
const buttonText = t('goBackTo', { hostname: nextHostname });

function handleClick() {
	const nextUrl = window.queryParams.next;
	if (nextUrl) {
		window.location.href = nextUrl;
	}
}
const hasNext = params.get('next') !== null;
</script>

<template>
	<Button class="go-back-button mt-4 max-w-full"
			v-if="hasNext"
			@click="handleClick">
		<ArrowLeftIcon />
		<span class="line-clamp-1">{{ buttonText }}</span>
	</Button>
</template>
